export default "__VITE_ASSET__2Cq9izIy__"